import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { CTAButton } from './shared/CTAButton';
export function SocialProof() {
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-202">
      <div className="max-w-6xl mx-auto px-4" data-id="element-203">
        {/* Work Gallery */}
        <div className="mb-24" data-id="element-204">
          <div className="text-center mb-12" data-id="element-205">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A2E] mb-4" data-id="element-206">
              No te lo prometemos: te lo mostramos
            </h2>
            <p className="text-lg text-gray-600" data-id="element-207">
              Son nuestros trabajos reales, con la técnica tal como se enseña en
              el programa.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-208">
            {[{
            label: 'Cutícula',
            desc: 'Terminación limpia'
          }, {
            label: 'Perfil',
            desc: 'Estructura + Apex'
          }, {
            label: 'Terminación',
            desc: 'Brillo y sellado'
          }, {
            label: 'Baby',
            desc: 'Degradé prolijo'
          }].map((item, idx) => <motion.div key={idx} whileHover={{
            y: -5
          }} className="aspect-[3/4] rounded-xl overflow-hidden relative group shadow-lg" data-id="element-209">
                {/* Placeholder for image - using gradient */}
                <div className={`w-full h-full bg-gradient-to-br from-[#F5E6E0] to-[#E0C0C8] group-hover:scale-110 transition-transform duration-500`} data-id="element-210" />

                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" data-id="element-211" />

                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white" data-id="element-212">
                  <p className="font-bold font-serif text-lg" data-id="element-213">{item.label}</p>
                  <p className="text-xs opacity-90" data-id="element-214">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center mt-10" data-id="element-215">
            <p className="text-[#9B2C5E] font-medium mb-6" data-id="element-216">
              Si tus sets no se ven así de consistentes, tu precio se te queda
              corto.
            </p>
            <CTAButton text="SÍ, QUIERO ESA TERMINACIÓN" variant="secondary" data-id="element-217" />
          </div>
        </div>

        {/* Testimonials */}
        <div className="mb-24" data-id="element-218">
          <h3 className="text-2xl font-serif text-center mb-10 text-[#1A1A2E]" data-id="element-219">
            Lo que dicen nuestras alumnas
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-220">
            {[{
            text: '...pude convertir mi casa en un taller y pude trabajar con cientos de mujeres.',
            author: 'Luz Marina Carmona'
          }, {
            text: '...aprendí desde cero y hoy mis ingresos se han triplicado… mi cartera de clientes crece todos los días…',
            author: 'Paola Andrea González'
          }].map((testi, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-[#F5E6E0] relative" data-id="element-221">
                <Quote className="absolute top-6 right-6 text-[#C9A96E]/20 w-10 h-10" data-id="element-222" />
                <div className="flex gap-1 mb-4" data-id="element-223">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-[#C9A96E] text-[#C9A96E]" data-id="element-224" />)}
                </div>
                <p className="text-gray-700 italic mb-6 text-lg" data-id="element-225">
                  "{testi.text}"
                </p>
                <p className="font-bold text-[#1A1A2E]" data-id="element-226">— {testi.author}</p>
              </div>)}
          </div>
        </div>

        {/* Instructor Bio */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-rose-900/5 flex flex-col md:flex-row gap-10 items-center" data-id="element-227">
          <div className="w-32 h-32 md:w-48 md:h-48 shrink-0 rounded-full bg-gradient-to-br from-[#9B2C5E] to-[#C9A96E] p-1" data-id="element-228">
            <div className="w-full h-full rounded-full bg-gray-200 overflow-hidden" data-id="element-229">
              {/* Avatar placeholder */}
              <img src="https://cdn.magicpatterns.com/uploads/6SbHQDU6kLWfvhp36GuV2Z/Clara-scaled-1-980x1373.jpg" alt="María Clara Casas" className="w-full h-full object-cover object-top" data-id="element-230" />
            </div>
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-231">
            <h3 className="text-2xl md:text-3xl font-serif text-[#1A1A2E] mb-2" data-id="element-232">
              Hola, soy{' '}
              <span className="text-[#9B2C5E]" data-id="element-233">María Clara Casas</span>
            </h3>
            <p className="text-[#C9A96E] font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-234">
              Fundadora de Nails Artist Expert
            </p>

            <div className="space-y-4 text-gray-600" data-id="element-235">
              <p data-id="element-236">
                Creé esta formación para mujeres que quieren vivir de esto en
                serio, pero sobre todo para quienes <strong data-id="element-237">ya trabajan</strong>{' '}
                y se cansaron de lo mismo: sets inconsistentes, tiempos eternos
                y esa inseguridad al cobrar.
              </p>
              <p data-id="element-238">
                Acá no venís a motivarte. Venís a{' '}
                <strong data-id="element-239">subir tu estándar técnico</strong> con un método claro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}